import React from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import WebFont from 'webfontloader';

import history from 'helpers/history';

import { Initializer, ResetPassword } from 'components'
import ExifTest from 'components/exif-test'

import './styles.scss';

WebFont.load({
  google: {
    families: ['Roboto:300,400,700'],
  },
});

export default class App extends React.PureComponent {
  render() {
    return (
      <Router history={history}>
        <Switch>
          <Route path='/exif-test' component={ExifTest} />
          <Route
            path='/reset-password/:user_id/:token'
            component={ResetPassword}
          />
          <Route path='/create' component={Initializer} />
          <Route path='/giftcard' component={Initializer} />
          <Route path='/:bookId?/:orderId?' component={Initializer} />
        </Switch>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/app/index.js